const onFailure = (error) => ({
  message: 'Erro ao corrigir o saldo da conta!',
  type: 'warning',
});

export default onFailure;
